import React from 'react';
import OrderPage from './components/OrderPage';

const CashifyStatus = () => {
  return (
    <div>
      <OrderPage type={'Cashify'} isCashify={true} />
    </div>
  );
};

export default CashifyStatus;
